<div class="ts-right-rail">
    <div class="ts-right-inner">

        <div class="ts-right-search-sticky">
            <div #searchBand class="ts-right-search-band">
                <app-search-bar></app-search-bar>
            </div>
        </div>

        <div class="ts-right-widgets-shell">
            <div #widgetsViewport class="ts-right-widgets-viewport">
                <div #widgetsInner class="ts-right-widgets-inner">
                    <div class="ts-right-widgets">

                        <div *ngIf="showWhoToFollow" class="ts-right-slot">
                            <app-who-to-follow [UserID]="UserID"
                                               (hasData)="toggleWidgetVisibility('whoToFollow', $event)">
                            </app-who-to-follow>
                        </div>

                        <div *ngIf="showTrendingTopics" class="ts-right-slot">
                            <app-trending-topics [UserID]="UserID"
                                                 (hasData)="toggleWidgetVisibility('trendingTopics', $event)">
                            </app-trending-topics>
                        </div>

                        <div *ngIf="showSponsoredPosts" class="ts-right-widget widget-container">
                            <app-sponsored-posts [UserID]="UserID"
                                                 (hasData)="toggleWidgetVisibility('sponsoredPosts', $event)">
                            </app-sponsored-posts>
                        </div>

                        <footer class="ts-right-footer">
                            <a routerLink="/tos">Terms of Service</a>
                            <a routerLink="/privacy">Privacy Policy</a>
                            <span class="ts-right-copy">© TruthShorts</span>
                        </footer>

                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
